exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-container[data-v-74f5061a]{position:relative}", ""]);

// exports
